import { GetServerSidePropsContext, InferGetServerSidePropsType } from "next";

import Container from "~/components/common/container";
import Grid from "~/components/common/grid";
import HighlightedText from "~/components/common/highlighted-text";
import CustomerCare from "~/components/customer-care/customer-care";
import LayoutPage from "~/components/layout/layout-page";
import ActionCodePasswordResetForm from "~/components/password-reset/action-code-password-reset-form";
import { usePageTracking } from "~/contexts/page-trackings";
import styles from "~/styles/pages/password-reset-request.module.scss";
import contentfulUtils from "~/utils/contentful-utils";
import ssrUtils from "~/utils/ssr-utils";

type Props = InferGetServerSidePropsType<typeof getServerSideProps>;

export default function PasswordResetRequestPage(props: Props) {
  usePageTracking("password-reset-request");

  return (
    <LayoutPage {...props} mainClasses={styles.pageBackground} navColor="white" hidePrefooter>
      <Container>
        <Grid>
          <div className={styles.passwordResetContainer}>
            <div className={styles.container}>
              {props.page.title ? (
                <h2
                  className={
                    contentfulUtils.isHighlightText(props.page.title) ? styles.headlineHighlighted : styles.headline
                  }
                >
                  <HighlightedText text={props.page.title} />
                </h2>
              ) : null}
              <ActionCodePasswordResetForm />
            </div>
          </div>
          <div className={styles.containerCustomerCare}>
            <CustomerCare />
          </div>
        </Grid>
      </Container>
    </LayoutPage>
  );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  if (context.locale === context.defaultLocale) {
    return {
      notFound: true,
    };
  }

  const pageData = await ssrUtils.getServerSideGenericPageData("password-reset-request", context);

  if (!pageData.page) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      ...pageData,
    },
  };
}
